/* Modulo FAQ Ledger — oversized-numeral accordion with grid-rows reveal.
   Single or multiple open (data-mode on the root), proper button aria-expanded
   + region panels, roving Arrow/Home/End keyboard nav across the ledger rows.
   Vanilla IIFE. Injected sections don't load the extension's moduloLazyInit, so
   we init on DOMContentLoaded and re-init on shopify:section:load (theme editor).
   Multiple instances on one page each init independently. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(root) {
    if (root.dataset.flBound === '1') return;
    root.dataset.flBound = '1';

    var multi = root.getAttribute('data-mode') === 'multiple';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-fl-item]'));
    if (!items.length) return;

    var buttons = items.map(function (it) { return it.querySelector('.modulo-fl__btn'); });

    function setOpen(item, open) {
      item.setAttribute('data-open', open ? 'true' : 'false');
      var btn = item.querySelector('.modulo-fl__btn');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.modulo-fl__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        if (!multi && !open) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, !open);
      });
    });

    // Roving keyboard support across the ledger rows.
    root.addEventListener('keydown', function (e) {
      var idx = buttons.indexOf(document.activeElement);
      if (idx === -1) return;
      var next = -1;
      switch (e.key) {
        case 'ArrowDown': next = (idx + 1) % buttons.length; break;
        case 'ArrowUp':   next = (idx - 1 + buttons.length) % buttons.length; break;
        case 'Home':      next = 0; break;
        case 'End':       next = buttons.length - 1; break;
        default: return;
      }
      e.preventDefault();
      if (buttons[next]) buttons[next].focus();
    });
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-fl]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  // Theme editor: re-init when this section is (re)rendered.
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();
